module.exports = __webpack_public_path__ + "static/media/tick-icon.636643ee.svg";